import { gql } from '@apollo/client';

const UPDATE_WALLET = gql`
  mutation UpdateWallet(
    $accountId: String!
    $authenticationMethod: WalletTokenAuthenticationMethod
    $comment: String!
    $operationType: WalletTokenOperationType!
    $reasonCode: WalletTokenReasonCode!
    $tokenId: String!
    $walletTypeId: String!
  ) {
    updateWalletToken(
      accountId: $accountId
      walletTokenUpdateInput: {
        authenticationMethod: $authenticationMethod
        comment: $comment
        operationType: $operationType
        reasonCode: $reasonCode
        tokenId: $tokenId
        walletTypeId: $walletTypeId
      }
    ) {
      success
    }
  }
`;

export { UPDATE_WALLET };
